import React from "react";
import OtpInput from "./OtpInput";

const ErrorAlert = ({ message }) => (
  <div className="login-error-box">
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#b91c1c"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, marginTop: "1px" }}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    {message}
  </div>
);

const OtpStep = ({ flow }) => {
  const {
    phoneNumber,
    otpComplete,
    verifyingOtp,
    resendCooldown,
    alert,
    handleOtpChange,
    handleVerifyOtp,
    resendOtp,
    resetToPhone,
  } = flow;

  const resendBlocked = resendCooldown > 0 || verifyingOtp;

  return (
    <div className="login-step login-otp-section">
      {alert.show && <ErrorAlert message={alert.message} />}

      <div>
        <p className="login-otp-hint" style={{ paddingBottom: "12px" }}>
          Enter the 6-digit code sent to{" "}
          <span className="login-otp-phone">{phoneNumber || "your phone"}</span>
        </p>
        <OtpInput
          length={6}
          disabled={verifyingOtp}
          onChange={handleOtpChange}
        />
      </div>

      <button
        className={`login-btn-primary${verifyingOtp ? " login-btn-primary--loading" : ""}`}
        onClick={() => handleVerifyOtp(flow.otp)}
        disabled={verifyingOtp || !otpComplete}
        style={{ opacity: !otpComplete && !verifyingOtp ? 0.45 : undefined }}
      >
        {verifyingOtp ? (
          <>
            <span className="login-btn-spinner" />
            Verifying…
          </>
        ) : (
          "Login"
        )}
      </button>

      <div className="login-otp-footer">
        <button
          className="login-btn-back"
          disabled={verifyingOtp}
          onClick={resetToPhone}
        >
          ← Change number
        </button>

        <button
          className={`login-resend-btn${resendBlocked ? " login-resend-btn--blocked" : ""}`}
          disabled={resendBlocked}
          onClick={resendOtp}
        >
          {resendCooldown > 0 ? (
            <>
              Resend in
              <span className="login-resend-countdown">{resendCooldown}s</span>
            </>
          ) : (
            "Resend code"
          )}
        </button>
      </div>
    </div>
  );
};

export default OtpStep;
